import { Jwt_token } from '../data/config';
import axios from 'axios';

export const configureFakeBackend = () => {


    let users = [{ email: 'test@gmail.com', password: 'test123' }];
    let realFetch = window.fetch;
    window.fetch = function (url, opts) {
        const isLoggedIn = opts.headers['Authorization'] === `Bearer ${Jwt_token}`;
        return new Promise((resolve, reject) => {
            // wrap in timeout to simulate server api call
            setTimeout(async () => {
                // authenticate - public
                if (url.endsWith('/users/authenticate') && opts.method === 'POST') {
                    const params = opts.body;
                    // Fake Users Data
                    const usersLogin = await axios.get(`${process.env.PUBLIC_URL}/api/EPortal2.0/AUTH/USERS_LOGIN.json`).then(res => { return res.data.data })
                    const user = usersLogin.find(x => x.email === params.email && x.password === params.password);
                    if (!user) return error({ message: 'Username or password is incorrect' });
                    return ok({token: Jwt_token, message: 'Login successful', user: user});
                }

                // get users - secure
                if (url.endsWith('/users') && opts.method === 'GET') {
                    if (!isLoggedIn) return unauthorised();
                    return ok(users);
                }

                // pass through any requests not handled above
                realFetch(url, opts).then(response => resolve(response));

                // private helper functions

                function ok(body) {
                    // resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(body)) })
                    resolve({ ok: true, ...body })
                }

                function unauthorised() {
                    // resolve({ status: 401, text: () => Promise.resolve(JSON.stringify({ message: 'Unauthorised' })) })
                    resolve({ status: 401, message: 'Unauthorised' })
                }

                function error(message) {

                    // resolve({ status: 400, text: () => Promise.resolve(JSON.stringify({ message })) })
                    reject({ status: 400, ...message })

                }
            }, 500);
        });
    }
}

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                localStorage.removeItem('token')
                localStorage.removeItem('profileURL')
            }
        }
        return data;
    });
}

export function authHeader() {
    // return authorization header with jwt token
    const currentUser = localStorage.getItem('token')
    if (currentUser) {
        return { Authorization: `Bearer ${currentUser}` };
    } else {
        return {};
    }
}